import Vue from 'vue';
export default Vue.extend({
  data: function () {
    return {};
  },
  computed: {
    approved() {
      return this.params.data.requested && this.params.data.approved == true;
    },
    rejected() {
      return this.params.data.requested && this.params.data.approved == false;
    },
    requested() {
      return this.params.data.requested && this.params.data.approved != true && this.params.data.approved != false;
    },
    request() {
      return !this.params.data.requested;
    },
  },
  beforeMount() {},
  mounted() {},
  methods: {
    btnClickedHandler(params) {
      this.params.clicked(params.data);
    },
  },
  template: `
    <span>
      <span v-show="approved" @click="btnClickedHandler(params)" class="text-success" style="cursor: pointer;">Download</span>
      <span v-show="rejected" @click="btnClickedHandler(params)" class="text-danger">Rejected</span>
      <span v-show="requested" @click="btnClickedHandler(params)" class="text-warning">Requested</span>
      <span v-show="request" @click="btnClickedHandler(params)" class="text-primary" style="cursor: pointer;">Request</span>
    </span>
  `,
});
